import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const value = inputElement.value;
    const sanitizedValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    inputElement.value = sanitizedValue;
  }
}
